import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { BasicPopoverTitle } from "../../../constants";
import { BasicPopoverData, BasicPopoverSubTitle } from "../../../data/uiKits/Popover";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import CommonPopover from "./common/CommonPopover";

const BasicPopover = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BasicPopoverTitle} span={BasicPopoverSubTitle} />
        <CardBody className="common-flex">
          {BasicPopoverData &&
            BasicPopoverData.map((item, index) => (
              <Fragment key={index}>
                <CommonPopover data={item} />
              </Fragment>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicPopover;
